import React, { useState, useEffect } from 'react';
import MyinvBasic from './MyinvBasic';
import { get_myinvestment_documents } from '../../services/common';
import moment from 'moment';

const MyinvDocs = ({ myinvId, docType = '' }) => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (myinvId) {
      getDocuments('');
    }
  }, [myinvId]);

  const getDocuments = async (search) => {
    try {
      const userToken = localStorage.getItem('systemToken') || '';
      const response = await get_myinvestment_documents(userToken, myinvId, docType, search);
      
      if (response.success === 200) {
        const docsData = response.docs.map(doc => ({
          ...doc,
          doc_time: moment(doc.created_at).format('DD MMM, YYYY')
        }));
        setDocs(docsData);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
    } finally {
      setLoading(false);
    }
  };

  const openLink = (docId) => {
    const link = document.getElementById(`URL${docId}`)?.value;
    if (link) {
      window.open(link, '_blank');
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    if (timer) {
      clearTimeout(timer);
    }
    
    const newTimer = setTimeout(() => {
      getDocuments(value);
    }, 300);
    
    setTimer(newTimer);
  };

  if (myinvId === '') {
    return null;
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <MyinvBasic myinvId={myinvId} />
      
      <div className="flex justify-center my-3">
        <div className="w-full pt-4">
          <div className="p-4 mb-4 bg-gray-50 rounded-lg h-full">
            <div className="flex mt-3">
              <div className="w-1/2">
                <div className="flex justify-between mb-2">
                  <h5 className="text-gray-600 text-sm font-bold">
                    Documents
                  </h5>
                </div>
              </div>
              <div className="w-1/2">
                <input
                  onChange={handleSearch}
                  value={searchTerm}
                  style={{ border: '1px solid grey', height: '35px', borderRadius: '5px' }}
                  type="text"
                  id="doc_search_input"
                  placeholder="Search doc name here.."
                  className="bg-white w-full pl-3"
                />
              </div>
            </div>
            <div className="mt-2">
              <div className="w-full overflow-x-auto">
                <table className="min-w-full table-auto border-collapse border border-gray-300">
                  <thead>
                    <tr>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Document Name</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date Added</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="4" className="border border-gray-300 px-2 py-1 text-center">
                          <div className="flex justify-center items-center py-4">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                            <span className="ml-2">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : docs.length > 0 ? (
                      docs.map((doc) => (
                        <tr key={doc.doc_id} className="hover:bg-gray-50">
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            {doc.doc_id}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            {doc.doc_name}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            {doc.doc_time}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            <input
                              id={`URL${doc.doc_id}`}
                              type="hidden"
                              value={doc.doc_url}
                            />
                            <div className="relative">
                              <button
                                className="text-lg text-blue-600 font-bold cursor-pointer"
                                onClick={() => openLink(doc.doc_id)}
                              >
                                Download
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                          No Records
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyinvDocs;
